module.exports = __webpack_public_path__ + "img/category-new-released-hover.84a0c847.png";